<section class="{{ class }}">
  <div class="{{ class + '__content' }}">
    <div class="{{ class + '__left' }}">
      <ng-container>
        <form [formGroup]="offerForm" (ngSubmit)="onFormSubmit()">
          <lib-package-summary
            *ngIf="canRenderSummary"
            (offerSummaryForm)="formInitialized($event)"
            [isNewCustomer]="true"
          ></lib-package-summary>
        </form>
      </ng-container>
    </div>
    <div class="{{ class + '__right' }}">
      <ng-container>
        <form [formGroup]="offerForm" (ngSubmit)="onFormSubmit()">
          <lib-new-customer-contact
            (customerContactForm$)="formInitialized($event)"
            [sendOfferResult]="sendOfferResult"
            [isSendingOffer]="sendingOffer"
            tagSize="s"
            (onSubmit)="onFormSubmit()"
            [isCheckoutPage]="true"
          ></lib-new-customer-contact>
        </form>
      </ng-container>
    </div>
  </div>
</section>
